import { PhotoInfoBlurb } from "src/api/graphql/__generated__/graphql";

const getPhotoInfoBlurb = (photo: {} | { photoInfoBlurb?: PhotoInfoBlurb }) => {
	if ("photoInfoBlurb" in photo && photo.photoInfoBlurb) {
		return {
			title: photo.photoInfoBlurb.title,
			message: photo.photoInfoBlurb.message ?? undefined,
			hasDelete: photo.photoInfoBlurb.hasDelete ?? false,
			hasClickAction: Boolean(photo.photoInfoBlurb.message || photo.photoInfoBlurb.hasDelete),
		};
	}
	return null;
};
export default getPhotoInfoBlurb;
